import { BefPageContainer } from '@beflam/bef-core';

declare var $: any;

export class TabManager {
    private pageController: any;

    constructor(pageController: any) {
        this.pageController = pageController;
    }

    /**
     * 关闭所有选项卡
     */
    tabCloseAll = () => {
        $('.page-tabs-content')
            .children('[data-id]')
            .each(function (index: any, tab: any) {
                $(tab).remove();
            });
        $('.page-tabs-content').css('margin-left', '0');
        this.closeAllTabs();
    };

    /**
     * 点击选项卡菜单
     */
    activeTab = (tab: any) => {
        if (!$(tab).hasClass('active')) {
            var activeId = $(tab).data('id');
            $(tab).addClass('active').siblings('.J_menuTab').removeClass('active');
            this.scrollToTab(tab);
            this.pageController.pageContainers.forEach((container: BefPageContainer) => {
                if (container.id === activeId) this.tabActive(container);
            });
        }
    };

    /**
     * 激活选项卡
     */
    private tabActive = (tab: BefPageContainer) => {
        this.pageController.active(tab);
        let listContainer: any[] = [];
        this.pageController.pageContainersChanged.emit(
            listContainer.concat(this.pageController.pageContainers)
        );
    };

    /**
     * 滚动到已激活的选项卡
     */
    showActiveTab = () => {
        this.scrollToTab($('.J_menuTab.active'));
    };

    /**
     * 关闭所有选项卡容器
     */
    private closeAllTabs = () => {
        var len = this.pageController.pageContainers.length;
        for (let i = len - 1; i > -1; i--) {
            this.tabClose(this.pageController.pageContainers[i]);
        }
    };

    /**
     * 关闭选项卡菜单
     */
    closeTab = (tab: any) => {
        var closeTabId = $(tab).parents('.J_menuTab').data('id');
        var currentWidth = $(tab).parents('.J_menuTab').width();
        var activeId = '';
        // 当前元素处于活动状态
        if ($(tab).parents('.J_menuTab').hasClass('active')) {
            // 当前元素后面有同辈元素，使后面的一个元素处于活动状态
            if ($(tab).parents('.J_menuTab').next('.J_menuTab').size()) {
                activeId = $(tab)
                    .parents('.J_menuTab')
                    .next('.J_menuTab:eq(0)')
                    .data('id');
                $(tab)
                    .parents('.J_menuTab')
                    .next('.J_menuTab:eq(0)')
                    .addClass('active');

                var marginLeftVal = parseInt(
                    $('.page-tabs-content').css('margin-left')
                );
                if (marginLeftVal < 0) {
                    $('.page-tabs-content').animate(
                        {
                            marginLeft: marginLeftVal + currentWidth + 'px',
                        },
                        'fast'
                    );
                }
                //  移除当前选项卡
                $(tab).parents('.J_menuTab').remove();
            }

            // 当前元素后面没有同辈元素，使当前元素的上一个元素处于活动状态
            if ($(tab).parents('.J_menuTab').prev('.J_menuTab').size()) {
                activeId = $(tab)
                    .parents('.J_menuTab')
                    .prev('.J_menuTab:last')
                    .data('id');
                $(tab).parents('.J_menuTab').prev('.J_menuTab:last').addClass('active');
                //  移除当前选项卡
                $(tab).parents('.J_menuTab').remove();
            } else {
                //  移除当前选项卡
                $(tab).parents('.J_menuTab').remove();
            }
            this.pageController.pageContainers.forEach((container: BefPageContainer) => {
                if (container.id === closeTabId) this.tabClose(container);
            });
            if (activeId !== '') {
                this.pageController.pageContainers.forEach((container: BefPageContainer) => {
                    if (container.id === activeId) this.tabActive(container);
                });
            }
        }
        // 当前元素不处于活动状态
        else {
            //  移除当前选项卡
            $(tab).parents('.J_menuTab').remove();
            this.scrollToTab($('.J_menuTab.active'));
        }
        return false;
    };

    /**
     * 查看左侧隐藏的选项卡
     */
    scrollTabLeft = () => {
        var marginLeftVal = Math.abs(
            parseInt($('.page-tabs-content').css('margin-left'))
        );
        // 可视区域非tab宽度
        var tabOuterWidth = this.calSumWidth(
            $('.content-tabs').children().not('.J_menuTabs')
        );
        //可视区域tab宽度
        var visibleWidth = $('.content-tabs').outerWidth(true) - tabOuterWidth;
        //实际滚动宽度
        var scrollVal = 0;
        if ($('.page-tabs-content').width() < visibleWidth) {
            return false;
        } else {
            var tabElement = $('.J_menuTab:first');
            var offsetVal = 0;
            while (offsetVal + $(tabElement).outerWidth(true) <= marginLeftVal) {
                //找到离当前tab最近的元素
                offsetVal += $(tabElement).outerWidth(true);
                tabElement = $(tabElement).next();
            }
            offsetVal = 0;
            if (this.calSumWidth($(tabElement).prevAll()) > visibleWidth) {
                while (
                    offsetVal + $(tabElement).outerWidth(true) < visibleWidth &&
                    tabElement.length > 0
                ) {
                    offsetVal += $(tabElement).outerWidth(true);
                    tabElement = $(tabElement).prev();
                }
                scrollVal = this.calSumWidth($(tabElement).prevAll());
            }
        }
        $('.page-tabs-content').animate(
            {
                marginLeft: 0 - scrollVal + 'px',
            },
            'fast'
        );
    };

    /**
     * 查看右侧隐藏的选项卡
     */
    scrollTabRight = () => {
        var marginLeftVal = Math.abs(
            parseInt($('.page-tabs-content').css('margin-left'))
        );
        // 可视区域非tab宽度
        var tabOuterWidth = this.calSumWidth(
            $('.content-tabs').children().not('.J_menuTabs')
        );
        //可视区域tab宽度
        var visibleWidth = $('.content-tabs').outerWidth(true) - tabOuterWidth;
        //实际滚动宽度
        var scrollVal = 0;
        if ($('.page-tabs-content').width() < visibleWidth) {
            return false;
        } else {
            var tabElement = $('.J_menuTab:first');
            var offsetVal = 0;
            while (offsetVal + $(tabElement).outerWidth(true) <= marginLeftVal) {
                //找到离当前tab最近的元素
                offsetVal += $(tabElement).outerWidth(true);
                tabElement = $(tabElement).next();
            }
            offsetVal = 0;
            while (
                offsetVal + $(tabElement).outerWidth(true) < visibleWidth &&
                tabElement.length > 0
            ) {
                offsetVal += $(tabElement).outerWidth(true);
                tabElement = $(tabElement).next();
            }
            scrollVal = this.calSumWidth($(tabElement).prevAll());
            if (scrollVal > 0) {
                $('.page-tabs-content').animate(
                    {
                        marginLeft: 0 - scrollVal + 'px',
                    },
                    'fast'
                );
            }
        }
    };

    /**
     * 关闭页面容器
     */
    private tabClose = (tab: BefPageContainer) => {
        this.pageController.close(tab);
    };

    /**
     * 关闭其他选项卡
     */
    closeOtherTabs = () => {
        $('.page-tabs-content')
            .children('[data-id]')
            .not('.active')
            .each((index: any, tab: any) => {
                $(tab).remove();

                this.pageController.pageContainers.forEach((container: BefPageContainer) => {
                    if (container.id === $(tab).data('id')) this.tabClose(container);
                });
            });
        $('.page-tabs-content').css('margin-left', '0');
    };

    /**
     * 计算元素集合的总宽度
     */
    calSumWidth = (elements: any) => {
        var width = 0;
        $(elements).each(function () {
            width += $(elements).outerWidth(true);
        });
        return width;
    };

    /**
     * 滚动到指定选项卡
     */
    scrollToTab = (element: any) => {
        var marginLeftVal = this.calSumWidth($(element).prevAll()),
            marginRightVal = this.calSumWidth($(element).nextAll());
        // 可视区域非tab宽度
        var tabOuterWidth = this.calSumWidth(
            $('.content-tabs').children().not('.J_menuTabs')
        );
        //可视区域tab宽度
        var visibleWidth = $('.content-tabs').outerWidth(true) - tabOuterWidth;
        //实际滚动宽度
        var scrollVal = 0;
        if ($('.page-tabs-content').outerWidth() < visibleWidth) {
            scrollVal = 0;
        } else if (
            marginRightVal <=
            visibleWidth -
            $(element).outerWidth(true) -
            $(element).next().outerWidth(true)
        ) {
            if (visibleWidth - $(element).next().outerWidth(true) > marginRightVal) {
                scrollVal = marginLeftVal;
                var tabElement = element;
                while (
                    scrollVal - $(tabElement).outerWidth() >
                    $('.page-tabs-content').outerWidth() - visibleWidth
                ) {
                    scrollVal -= $(tabElement).prev().outerWidth();
                    tabElement = $(tabElement).prev();
                }
            }
        } else if (
            marginLeftVal >
            visibleWidth -
            $(element).outerWidth(true) -
            $(element).prev().outerWidth(true)
        ) {
            scrollVal = marginLeftVal - $(element).prev().outerWidth(true);
        }
        $('.page-tabs-content').animate(
            {
                marginLeft: 0 - scrollVal + 'px',
            },
            'fast'
        );
    };

    /**
     * 绑定事件处理器
     */
    bindEventHandlers = () => {
        function closeTab(this: TabManager, args: any) {
            this.closeTab(args.target);
        }
        $('.J_menuTabs').off('click.closeTab', '.J_menuTab i');
        $('.J_menuTabs').on('click.closeTab', '.J_menuTab i', closeTab.bind(this));

        function closeOtherTabs(this: TabManager) {
            this.closeOtherTabs();
        }
        $('.J_tabCloseOther').off('click.closeOtherTabs');
        $('.J_tabCloseOther').on('click.closeOtherTabs', closeOtherTabs.bind(this));

        function showActiveTab(this: TabManager) {
            this.showActiveTab();
        }
        $('.J_tabShowActive').off('click.showActiveTab');
        $('.J_tabShowActive').on('click.showActiveTab', showActiveTab.bind(this));

        function activeTab(this: TabManager, args: any) {
            this.activeTab(args.target);
        }
        $('.J_menuTabs').off('click.activeTab', '.J_menuTab');
        $('.J_menuTabs').on('click.activeTab', '.J_menuTab', activeTab.bind(this));

        function scrollTabLeft(this: TabManager) {
            this.scrollTabLeft();
        }
        // 左移按扭
        $('.J_tabLeft').off('click.scrollTabLeft');
        $('.J_tabLeft').on('click.scrollTabLeft', scrollTabLeft.bind(this));

        function scrollTabRight(this: TabManager) {
            this.scrollTabRight();
        }
        // 右移按扭
        $('.J_tabRight').off('click.scrollTabRight');
        $('.J_tabRight').on('click.scrollTabRight', scrollTabRight.bind(this));

        var tabCloseAll = () => {
            this.tabCloseAll();
        };
        // 关闭全部
        $('.J_tabCloseAll').off('click.tabCloseAll');
        $('.J_tabCloseAll').on('click.tabCloseAll', tabCloseAll);
    };
}
